
<template>
	<div id="appbox">
		<div class="top_heard">
			<div class="top_minemsgbox">
				<div class="top_institutionmsg">
					黑龙江省文化和旅游厅 | 黑龙江省研学实践教育协会
				</div>
				<div class="welcome">
					欢迎您访问：河南研学平台！
				</div>
				<div class="top_right">
					<div class="top_Mobiletype">
						手机端
					</div>
					<div class=""  @click="goregister()">
						注册
					</div>
				</div>
			</div>
			<div class="top_box">
				<div class="logo_box">
					<img src="../../../static/img/logo.jpg"   alt="" style="margin-top: 0px !important;"  height="" srcset="">
				</div>
				<div class="top_search_box">
					<div class="top_search">
						<i class="el-icon-search"></i>
						<input type="text" autocomplete="off" placeholder="请输入您搜索的内容" class="el-input__inner">
						<img class="top_search_icon" src="../../../static/img/顶部搜素图标.png" alt="" srcset="">
					</div>
					  <el-select v-model="value" size="medium" class="top_search_type" placeholder="搜索类型">
					    <el-option
					      v-for="item in options"
					      :key="item.value"
					      :label="item.label"
					      :value="item.value">
					    </el-option>
					  </el-select>
				</div>
			</div>
			<div class="top_tab_box">
				<div class="toptabnav">
						<el-menu
						  :default-active="activeIndex2"
						  class="el-menu-demo"
						  mode="horizontal"
						  @select="handleSelect"
						  router
						  background-color="#1b9d57"
						  text-color="#FFFFFF"
						  active-text-color="#FFFFFF">
						<el-menu-item index="/Home">首页</el-menu-item>
						<el-menu-item index="/Newslist" >研学资讯</el-menu-item>
						<el-menu-item index="/Courselist" >研学课程</el-menu-item>
						<el-menu-item index="/Camplist" >研学营地</el-menu-item>
						<el-menu-item index="/Baselist" >研学基地</el-menu-item>
						<el-menu-item index="/Campmap" >研学地图</el-menu-item>
<!--						<el-menu-item index="/Activitylist">活动中心</el-menu-item>-->
              <el-submenu index="/Mentorlist">
						    <template slot="title">证书管理</template>
						    <!-- <el-menu-item><a href="https://admin.henanyanxue.com/_uc/index" target="_blank" style="color: #ffffff;">学生证书申请</a></el-menu-item> -->
						    <el-menu-item index="/Mentorlist" >导师证书查询</el-menu-item>
						   
						  </el-submenu>
						<el-menu-item index="/Linelist" >研学线路</el-menu-item>
						<!-- <el-menu-item index="/" >研学政策</el-menu-item> -->
					</el-menu>
				</div>
				<div class="top_banner">
					<el-carousel ref="carousel" :interval="4000"  height="610px">
					  <el-carousel-item v-for="item in platelist" :key="item">
					    <h3 class="medium" style="width: 100%;height: 100%;"><img :src="item.thumb"  style="width: 100%;height: 100%;" alt="" srcset=""></h3>
					  </el-carousel-item>
					</el-carousel>
				</div>
	<!-- 			<div class="top_plate">
					<div class="plate_item" v-for="(plate, index) in platelist" :key="plate" @mouseover="showstep(index)" @click="goplate(plate.id)" >
						<div class="plate_icon">
							<img :src="plate.icon" alt="" srcset="">
						</div>
						<div class="plate_title">
							{{plate.title}}
						</div>
					</div>
				</div> -->
			</div>
		</div>
		<div class="Home_column1">
			<div class="Home_imgs">
				<el-carousel :interval="4000" indicator-position="outside" height="370px">
				  <el-carousel-item v-for="item in banner" :key="item">
					<h3 class="medium" style="width: 100%;height: 100%;position: relative;"><img :src="item.icon"  style="width: 100%;height: 100%;" alt="" srcset="">
					<div class="home_banner_text">
						{{item.title}}
					</div></h3>
				  </el-carousel-item>
				</el-carousel>
			</div>
			<div class="newnews_box">
				<div class="news_top">
					<div class="news_title">
						最新消息
					</div>
					<div class="news_gomroe">
						查看更多
					</div>
				</div>
				<div class="newslist">
					<div class="news_item"  v-for="item in newslist" :key="item"  @click="gonews(item.id)"  >
						<span style="display: inline-block;padding: 0;min-width: 8px;height: 8px;width: 8px;background: #1b9d57;margin-right: 4px;"></span>{{item.title}}
					</div>
				</div>
			</div>
		</div>
		<div class="Home_column2">
			<div class="column_titlebox">
				<div class="column_title">
					推荐研学课程
				</div>
				<div class="column_gomore">
					查看更多
				</div>
			</div>
			<div class="column2_box">
				<div class="column2_item"   v-for="item in lessonlist" :key="item" @click="golesson(item.id)">
					<div class="column2_img">
						<img :src="item.icon" alt="" srcset="">
					</div>
					<div class="column2_title">
						<div class="item_title">
							{{item.title}}
						</div>
						<div class="item_subtitle">
							{{item.category}}
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="Home_column2">
			<div class="column_titlebox">
				<div class="column_title">
					精品优质线路
				</div>
				<div class="column_gomore">
					查看更多
				</div>
			</div>
			<div class="column2_box">
				<div class="column2_item"   v-for="item in linelist" :key="item" @click="goline(item.id)">
					<div class="column2_img">
						<img :src="item.icon" alt="" srcset="">
					</div>
					<div class="column2_title">
						<div class="item_title">
							{{item.title}}
						</div>
						<div class="item_subtitle">
							{{item.unit}}
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="Home_column2">
			<div class="column_titlebox">
				<div class="column_title">
					营地基地展示
				</div>
				<div class="column_gomore">
					查看更多
				</div>
			</div>
			<div class="column2_box">
				<div class="column2_item"   v-for="item in Camplist" :key="item" @click="gocamp(item.id)">
					<div class="column2_img">
						<img :src="item.icon" alt="" srcset="">
					</div>
					<div class="column2_title">
						<div class="item_title">
							{{item.title}}
						</div>
						<div class="item_subtitle">
							{{item.address}}
						</div>
					</div>
					<div class="camp_rank">
						省级
					</div>
				</div>
			</div>
		</div>
		<div class="Home_column2">
			<div class="column_titlebox">
				<div class="column_title">
					优秀研学指导师
				</div>
				<div class="column_right">
					<div class="mentor_type" style=" border-left: 0px !important;" >
						教学指指导师
					</div>
					<div class="mentor_type" >
						活动指指导师
					</div>
					<div class="mentor_type" >
						管理指指导师
					</div>
					<div class="gomore_mentor">
						更多指导师>
					</div>
				</div>
			</div>
			<div class="column2_box">
				<div class="mentor_item"   v-for="item in mentorlist" :key="item">
					<div class="mentor_imgs">
						<img :src="item.icon" alt="" srcset="">
					</div>
					<div class="mentor_msgbox">
						<div class="mentor_title">
							{{item.title}}
						</div>
						<div class="mentor_subtitle">
							{{item.titles}}
						</div>
						<div class="mentor_msg">
							指导师级别:{{item.titles}}
						</div>
						<div class="mentor_msg">
							备案编号:{{item.titles}}
						</div>
						<!-- <div class="mentor_msg">
							发证日期:{{item.titles}}
						</div>
						<div class="mentor_msg">
							所在机构:{{item.campname}}
						</div> -->
					</div>
				</div>
			</div>
		</div>
		<div class="Home_column2">
			<div class="column_titlebox">
				<div class="column_title">
					研学机构
				</div>
				<div class="column_gomore">
					查看更多
				</div>
			</div>
			<div class="column2_box">
				<div class="Traveler_item"   v-for="item in mentorlist" :key="item" >
					<div class="Traveler_title">
						青年旅行社
					</div>
					<div class="Traveler_msg">
						哈尔滨南岗区红军街15号奥维斯发展大厦22层F座
					</div>
					<div class="Traveler_msg">
						电话: 400-016-3218
					</div>
				</div>
			</div>
		</div>
		<div class="Home_column2">
			<div class="column_titlebox">
				<div class="column_title">
					研学产品
				</div>
				<div class="column_gomore">
					查看更多
				</div>
			</div>
			<div class="column2_box">
				<div class="product_box">
					<div class="prodduct_item" style="border-left: 0px;">
						<div class="prodduct_title" style="background: #e1251a; color: #ffffff;" >
							精选
						</div>
						<div class="product_msg" style="color: #e1251a;">
							猜你喜欢
						</div>
					</div>
					<div class="prodduct_item">
						<div class="prodduct_title">
							智能手环
						</div>
						<div class="product_msg">
							追踪定位
						</div>
					</div>
					<div class="prodduct_item">
						<div class="prodduct_title">
							研学保险
						</div>
						<div class="product_msg">
							安全保证
						</div>
					</div>
					<div class="prodduct_item">
						<div class="prodduct_title">
							研学百货
						</div>
						<div class="product_msg">
							研学用具
						</div>
					</div>
					<div class="prodduct_item">
						<div class="prodduct_title">
							研学拼团
						</div>
						<div class="product_msg">
							优惠抢拼
						</div>
					</div>
					<div class="prodduct_item">
						<div class="prodduct_title">
							积分商城
						</div>
						<div class="product_msg">
							其他
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="Home_column2" style="	margin-top: 40px;">
			<div class="column2_box">
				<div class="column_blockimg">
					<img src="../../../static/img/首页未定栏目1.jpg" alt="" srcset="">
				</div>
				<div class="column_blockimg">
					<img src="../../../static/img/首页未定栏目2.jpg" alt="" srcset="">
				</div>
				<div class="column_blockimg">
					<img src="../../../static/img/首页未定栏目3.jpg" alt="" srcset="">
				</div>
				<div class="column_blockimg">
					<img src="../../../static/img/首页未定栏目4.jpg" alt="" srcset="">
				</div>
			</div>
		</div>
		<div class="pagesbottom_box">
			<div class="subtexts">
				<div>关于我们</div>
				<div>商务合作</div>
				<div>招商合作</div>
				<div>广告服务</div>
				<div>线下体验店</div>
				<div>客服中心</div>
				<div>在线留言</div>
				<div>合作伙伴</div>
				<div>联系我们</div>
				<div>人员招聘</div>
				<div>网站地图</div>
				<div>热点关注</div>
				<div>网盟合作</div>
				<div>音乐</div>
			</div>
			<div class="row">
				<!-- <div class="copy-left">
					<p><i class="el-icon-phone-outline"></i>{{pcsetdata.phone}}</p>
					<p><i class="el-icon-message"></i>{{pcsetdata.email}}</p>
					<p style="font-size: 13px;">地址信息：{{pcsetdata.address}}</p>
				</div> -->
				
				<div class="copy-left">
					<div class="bottom_logo">
						<img src="../../../static/img/logo.jpg" alt="" style="margin-top: 0px !important;"  height="" srcset="">
					</div>
					<!-- <div class="copy-right">
						<img src="../../../static/img/gzhsuncode.jpg" />
					</div>
					<div class="copy-right">
						<img src="../../../static/img/suncode.jpg" />
					</div> -->
				</div>
				<div class="bottom_right">
					<div class="bottom_msg">
						{{pcsetdata.foot}}
					</div>
					<div class="bottom_msg">
						<a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener">{{' '+pcsetdata.icp}}</a>
					</div>
					<div class="bottom_msg">
						课程适用人群:学生群体
					</div>
				</div>
				
			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { getBanner, getWxLogin, getAclist, getNewslist, getCategory, getCamplist, getActivitylist, getPac, getCourselist, getPc, getNt, getTeacher, getAdvbanner, getPlate,getLinelist} from '@/request/api'
import { Loading } from 'element-ui';
// import navTab from '../Navtab/navtab'
	
export default {
  name: "Home",
    // components: {
    //   navTab
    // },
  data(){
	  return {
	        // navList: ['标题1', '标题2', '标题3', '标题4'],
	        // navDropList: [{
	        //   title: '菜单1',
	        //   list: ['菜单标题1', '菜单标题2', '菜单标题3']
	        // }, {
	        //   title: '菜单2',
	        //   list: ['菜单标题1', '菜单标题2']
	        // }],
			// activeIndex: '1',
			activeIndex2: '/Home',
			platelist:[],
			userInfo: {
			  username: "",
			  education_name: "",
			  role_level: ""
			},
			  options: [{
			          value: '选项1',
			          label: '黄金糕'
			        }, {
			          value: '选项2',
			          label: '双皮奶'
			        }, {
			          value: '选项3',
			          label: '蚵仔煎'
			        }, {
			          value: '选项4',
			          label: '龙须面'
			        }, {
			          value: '选项5',
			          label: '北京烤鸭'
			        }],
			        value: '',
			newstypes:[],
			Camplist:[],
			newscategory_id:0,
			logintype:true,
			banner:[
			],
			newslist:[],
			aclist:[],
			lessonlist:[],
			categorytypes:[],
			linelist:[],
			lessoncategory_id:0,
			pcsetdata:{},
			ntlist:[],
			mentorlist:[],
			mentor_index:'',
			mentorindex:0,
			mentortotal:0,
			advbanner:[],
	      }
  },
  beforeCreate(){
	   const loading = this.$loading({
			lock: true,
			text: '页面载入……',
			// spinner: 'el-icon-loading',
			background: '#ffffff'
		  });
  },
  created() {
	  this.getpcset()
  },
  mounted() {
	  this.getPlate()
	  this.getnewstypes()
    this._getbanner() 
	this._getNewslist()
	this._getCamplist()
	this._getAclist()
	this.getlessontypes()
	this.getlinelist()
	this.getmentor()
	this.getNt()
	this.getAdvbanner()
	// this.getlessonlist()
  },
  beforeDestroy(){
	
  },
  methods: {
	  goregister(e){
	  			  this.$router.push({
	  			    path: "/register",
	  			    name: "/register",
	  			  		  query: {
	  			  		  }
	  			  });
	  },
	   showstep(ind) {
	        this.$refs.carousel.setActiveItem(ind)
	      },
		  goplate(id){
			  
		  },
	  getPlate(){
		var data={
			
		}  
		getPlate(data).then(res=>{
			this.platelist=res.data.data
		})
	  },
	  getlinelist(){
		  var data={
			  page_index: 1,
			  page_size: 4,
		  }
		  getLinelist(data).then(res=>{
		  	console.log(res.data)
		  	this.linelist=res.data.data.list
		  	// this.quicklist=res.data.data.list
		  }).catch(error => {
		  	console.error(error);
		  });
	  },
	  getAdvbanner(){
		var data={
			is_pc:2,
			flag:'A'
		}  
		getAdvbanner(data).then(res=>{
			console.log('getAdvbanner',res)
			this.advbanner=res.data.data
		})
	  },
	  changementor(e){
		console.log('1112',e)  
		this.mentorindex=e+1
		this.getmentor()
	  },
	  mentoropen(index){
		this.mentor_index=index  
	  },
	  relist(data){
		  const list = data.split(',');
		  return list
	  },
	  getmentor(){
		  var data={
			  page_index:1,
			  page_size:3
		  }
		  getTeacher(data).then(res=>{
			  this.mentorlist=res.data.data.list
		  })
	  },
	  getNt(){
		getNt().then(res=>{
			this.ntlist=res.data.data
		})  
	  },
	  getpcset(){
		getPc().then(res=>{
			this.pcsetdata=res.data.data
		})  
	  },
	  golesson(e) {
	    this.$router.push({
	      path: "/CourseDetails",
	      name: "CourseDetails",
	      query: {
	        id: e
	      }
	    });
	  },
	  camptypetab(val){
	  			  // this.lessoncategory_id=val
	  			  this.getlessonlist()
	  },
	  getlessontypes(){
	  			var data={}
	  			getPac(data).then(res=>{
	  				console.log(res.data)
	  				this.categorytypes=res.data.data.cat
	  				// this.periodtypes=res.data.data.res
	  				// this.lessoncategory_id=res.data.data.cat[0].id
	  				this.getlessonlist()
	  			}).catch(error => {
	  			  console.error(error);
	  			});
	  },
	  getlessonlist(){
	  			var data={
	  				// type:this.camptype,
	  				category_id:this.lessoncategory_id,
	  				page_index: 1,
	  				page_size: 4,
	  			}  
	  			getCourselist(data).then(res=>{
	  				console.log(res.data)
	  				this.lessonlist=res.data.data.list
					const loading = this.$loading({
					         lock: true,
					         text: 'Loading',
					         spinner: 'el-icon-loading',
					         background: 'rgba(0, 0, 0, 0.7)'
					       });
					loading.close();
	  				// this.total=res.data.data.total
	  				// this.quicklist=res.data.data.list
	  			}).catch(error => {
	  				console.error(error);
	  			});
	  },
	  newshandleClick(e){
			console.log(e,this.category_id)
			this._getNewslist()
	  },
	  getnewstypes(){
		  var data={}
		  getCategory(data).then(res=>{
				  console.log(res.data)
				  this.newstypes=res.data.data
				  this.newscategory_id=res.data.data[0].id
				  this._getNewslist()
			}).catch(error => {
			  console.error(error);
			});
	  },
	  _getNewslist(){
		  var data={
			page_index:1,
			page_size:7,
			category_id:this.newscategory_id,
		  }
		getNewslist(data).then(res=>{
			console.log(res.data)
			this.newslist=res.data.data.list
		  }).catch(error => {
			  console.error(error);
			});
	  },
	  _getCamplist(){
		  var data={
			  page_index:1,
			  page_size:4
		  }
		  getCamplist(data).then(res=>{
				  console.log(res.data)
				  this.Camplist=res.data.data.list
		  }).catch(error => {
		  				  console.error(error);
		  			});
	  },
	  _getAclist(){
		  var data={
			  page_index:1,
			  page_size:3
		  }
		  getAclist(data).then(res=>{
		  			  console.log(res.data)
					  this.aclist=res.data.data.list
		  			  // this.banner=res.data.data
		  }).catch(error => {
				  console.error(error);
			});
	  },
	  _getColumn(){
		  getColumn().then(res=>{
		  			  console.log(res.data)
		  			  // this.banner=res.data.data
		  }).catch(error => {
		  			  console.error(error);
		  			});
	  },
	  _getbanner(){
		  console.log(22233, getBanner())
			var data={
				is_pc:2
			}
		  getBanner(data).then(res=>{
			  console.log(res.data)
			  this.banner=res.data.data
		  }).catch(error => {
			  console.error(error);
			});
	  },
	handleSelect(key, keyPath) {
		console.log(key, keyPath);
	},
	golist(e){
		this.$router.push({
		  path: "/"+e,
		  name:"/"+e,
			query: {
			}
		});
	},
	gontdetails(e){
		this.$router.push({
		  path: "/Ntdetails",
		  name: "Ntdetails",
		  query: {
		    id: e
		  }
		});
	},
    gonews(e){
		this.$router.push({
		  path: "/NewsDetails",
		  name: "NewsDetails",
		  query: {
		    id: e
		  }
		});
	},
	gocamp(e){
		this.$router.push({
		  path: "/CampDetails",
		  name: "CampDetails",
		  query: {
		    id: e
		  }
		});
	},
	goline(e){
		this.$router.push({
		  path: "/LineDetails",
		  name: "LineDetails",
		  query: {
		    id: e
		  }
		});
	},
	goactivity(e){
		this.$router.push({
		  path: "/Activitydetails",
		  name: "Activitydetails",
		  query: {
		    id: e
		  }
		});
	},
  }
};
	
</script>

<style scoped>
	
	.home_banner_text{
		width: 100%;
		    padding: 4px 0;
		    background: rgba(71,86,105,.51);
		    color: #fff;
		    text-align: center;
		    position: absolute;
		    bottom: 0;
		    height: 18px;
		    line-height: 18px;
		    font-size: 14px;
	}
	body{
		background: #ffffff;
	}
	#appbox{
		background: #ffffff;
	}
	.Home_column1{
		width: 1180px;
		display: flex;
		margin: 0 auto;
		justify-content: space-between;
		margin-top: 50px;
	}
	.Home_column2{
		width: 1180px;
		margin: 0 auto;
		margin-top: 20px;
	}
	.column_titlebox{
		width: 100%;
		padding: 20px 0px;
		display: flex;
		justify-content: space-between;
		align-items: flex-end;
	}
	.column_title{
		font-size: 22px;
		color: #1b9d57;
	}
	.column_right{
		display: flex;
		align-items: flex-end;
		
	}
	.column_right:first-child {
		 border-left: 0px !important;
	  /* 父元素的第一个子元素的样式 */
	}
	.mentor_type{
		padding: 0px 10px;
		font-size: 16px;
		border-left: 1px solid #606266;
		color:#606266 ;
	}
	.gomore_mentor{
		margin-left: 20px;
		font-size: 14px;
		color:#606266 ;
	}
	.column_gomore{
		text-align: right;
		font-size: 16px;
		color: #C0C4CC;
	}
	.column2_box{
		width: 100%;
	
		display: flex;
		justify-content: space-between;
		align-items: flex-end;
	}
	.column_blockimg{
		width: 285px;
		 box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
	}
	
	.product_box{
		width: 1180px;
		display: flex;
		align-items: center;
		justify-content: center;
		border: 1px solid #EBEEF5;
		padding: 15px 0px;
		border-radius: 5px;
		/* height: ; */
	}
	.prodduct_item{
		width: 195px;
		height: 60px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
		border-left: 1px solid #EBEEF5;
	}
		
	.prodduct_title{
		padding: 4px 10px;
		border-radius: 10px;
		margin-bottom: 4px;
		font-size: 18px;
		font-weight: 600;
		color: #303133;
	}
	.product_msg{
		font-size: 14px;
		color: #909399;
	}
	
	.mentor_item{
		padding: 20px;
		width: 330px;
		display: flex;
		align-items: center;
		background: #f9f9f9;
		border-radius: 8px;
	}
	.mentor_imgs{
		width:100px;
		height: 135px;
	}
	.mentor_imgs img{
		border-radius: 5px;
		width: 100%;
		height: 100%;
	}
		
	.mentor_msgbox{
		margin-left: 20px;
		flex: 1;
		display: flex;
		flex-direction: column;
		
	}
	.mentor_title{
		font-size: 18px;
		font-weight: 600;
		color: #303133;
		text-align: left;
	}
	.mentor_subtitle{
		font-size: 15px;
		color: #909399;
		margin: 10px 0px;
		text-align: left;
	}
	.mentor_msg{
		font-size: 12px;
		color: #909399;
		margin: 1px;
		text-align: left;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		
	}
	.Traveler_item{
		padding: 20px;
		width: 340px;
		background: #f9f9f9;
		border-radius: 8px;
	}
	.Traveler_title{
		width: 100%;
		font-size: 18px;
		color: #303133;
		text-align: left;
		margin-bottom: 10px;
	}
	.Traveler_msg{
		width: 100%;
		font-size: 14px;
		color: #909399;
		text-align: left;
	}
	.prodduct_item{
		
	}
	.column2_item{
		width: 265px;
		height: 260px;
		border-radius: 15px;
		position: relative;
	}
	.camp_rank{
		position: absolute;
		left: 0px;
		top: 0px;
		padding: 4px 8px;
		font-size: 14px;
		border-radius: 10px 0px;
		    background: #fe3113;
		    color: #ffffff;
	}
	.column2_img{
		width: 100%;
		height: 180px;
	}
	.column2_img img{
		width: 100%;
		height: 100%;
		border-radius:10px 10px 0px 0px;
	}
	.column2_title{
		padding: 10px;
		background: #f9f9f9;
		border-radius: 0px 0px 10px 10px;
		padding-bottom: 15px;
	}
	.item_title{
		font-size: 18px;
		font-weight: 600;
		color: #303133;
		margin-bottom: 15px;
		text-align: left;
		overflow: hidden;
		    white-space: nowrap;
		    text-overflow: ellipsis;
		/* text-overflow: ellipsis;
		white-space: normal;
		overflow: hidden;
		display: -webkit-box;
		-webkit-line-clamp: 1;
		-webkit-box-orient: vertical; */
	}
	.item_subtitle{
		font-size: 14px;
		color: #909399;
		text-align: left;
		overflow: hidden;
		    white-space: nowrap;
		    text-overflow: ellipsis;
	}
	
	
	.Home_imgs{
		width: 575px;
		
	}
	.newnews_box{
		width: 580px;
	}
	.news_top{
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: flex-end;
	}
	.news_title{
		padding: 15px;
		border-bottom: 2px solid #1b9d57;
		color: #1b9d57;
		font-size: 22px;
		font-weight: 600;
	}
	.news_gomroe{
		padding: 17px 0px;
		text-align: right;
		flex: 1;
		font-size: 16px;
		border-bottom: 1px solid #E4E7ED;
		color: #C0C4CC;
	}
	.newslist{
		width: 100%;
		display: flex;
		flex-direction: column;
		margin: 0px;
	}
	.news_item{
		text-align: left;
	}
	
	
	.plate_icon{
		width:70px;
		height: 70px;
	}
	.plate_icon img{
		width: 100%;
		width: 100%;
	}
	.plate_title{
		margin-top: 10px;
	}
	.plate_item{
		width: 340px;
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		border-left: 1px solid #ffffff;
		color: #ffffff;
		font-size: 22px;
		font-weight: 600;
	}
	.plate_item:hover{
		background: #cccccc38;
	}
	.plate_item:active{
		background:#0f6a8f36;
	}
	 .plate_item:first-child {
		 border-left: 0px solid #ffffff;
	  /* 父元素的第一个子元素的样式 */
	}
	.plate_icon{
		
	}
	
	.top_minemsgbox{
		width: 1230px;
		padding:10px 0px;
		/* height: 110px; */
		display: flex;
		align-items: center;
		justify-content: flex-start;
		margin: 0 auto;
		font-size: 15px;
		color:#606266;
		/* padding: 120px; */
	}
	.welcome{
		color:#187192;
		font-size: 16px;
		margin:0px 40px;
		/* flex: 1; */
		text-align: left;
		margin-right: 200px;
		
	}
	.top_right{
		display: flex;
		align-items: center;
	}
	.top_Mobiletype{
		padding: 4px 15px;
		background: #1b9d57;
		color: #ffffff;
		border-radius: 20px;
		margin-right: 10px;
		font-size: 14px;
	}
	.top_box{
		width: 1230px !important;
		justify-content: flex-start;
	}
	.logo_box{
		margin-right: 300px;
	}
	.top_search_box{
		display: flex;
		align-items: center;
	}
	.top_search{
		display: flex;
		align-items: center;
		border: 1.5px solid #1b9d57;
		position: relative;
		padding: 6px 20px;
		border-radius: 60px;
		    margin: 0px 20px;
			font-size: 16px;
	}
	.top_search input{
		width: 300px;
		color:#747dce;
	}
	.top_search i{
		font-size: 20px;
		font-weight: 600;
		color: #C0C4CC;
	}
	.top_search_icon{
		width: 64px !important;
		height: 64px !important;
		object-fit:contain;
		position: absolute;
		right: -10px;
	}
	.toptabnav{
		height: 70px !important;
	/* 	background: #1b9d5700;
		position: absolute; */
		z-index: 99;
	}
	.top_tab_box{
		width: 100%;
		position: relative;
	}
	.top_banner{
		
	}
	.top_plate{
		/* position: absolute; */
		/* bottom: 0px; */
		width: 100%;
		height: 164px;
		display: flex;
		justify-content: center;
		background: #1b9d57;
		z-index: 99;
	}
	
	
	
	.el-tag--mini{
		font-size: 8px !important;
		    padding: 0 2.8px;
	}
	.mentor{
		width: 1100px;
		margin: 0 auto;
		margin-top: 20px;
		
	}
	.mentor_box{
		width: 1100px;
		display: flex;
		/* justify-content: ; */
		flex-wrap: wrap;
		
		background: #30313336;
	}
	.mentor_msg_box{
		position: absolute;
		width: 180px;
		height: 245px;
		background: #333333c7;
		color: #ffffff;
		top: 0px;
		    left: 0px;
	}
/* 	.mentor_title{
		padding:15px 10px;
		margin: 0px 10px;
		margin-top: 50px;
		font-size: 20px;
		font-weight: 500;
		border-bottom: 1px solid #ffffff;
	} */
	.mentor_tags{
		padding: 9px;
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		justify-content: space-between;
	}
	.mentor_camp{
		font-size: 14px;
		text-align: left;
		padding: 10px;
		padding-top: 0px;
	}
	.ntmain{
		width: 1000px;
	}
	.nttext:hover{
		color: #1b9d57 !important;
	}
	.ntbox{
		width: 1060px;
		    background: #ffffff;
		    margin: 10px auto;
		    display: flex;
		    align-items: center;
		    padding: 0px 20px;
	}
	.nticon{
		width: 30px;
		height: 30px;
		margin-right: 10px;
	}
	.el-carousel__item h3{
		opacity: 1 !important;
	}
	.lessonbox{
		width: 1100px;
		margin: 0 auto;
		margin-top: 20px;
	}
	.home_titlebox{
		width: 1100px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.next_text{
		margin-bottom: 20px;
		font-size: 16px;
	}
	.camplist{
		padding: 20px;
		width:1060px ;
		background: #ffffff;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		align-items: center;
	}
	.lessonlist{
		padding: 20px;
		width:1060px ;
		background: #ffffff;
		flex-wrap: wrap;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.actlist{
		padding: 20px;
		width:1060px ;
		background: #ffffff;
		flex-wrap: wrap;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.actmsgbox{
		width: 320px;
		padding: 10px;
		display: flex;
		justify-content: space-between;
		align-items: flex-start;
	}
	.actbutton{
		width: 80px;
		height: 30px;
		line-height: 30px;
		font-size: 18px;
		color: #ffffff;
		background: #1b9d57;
	}
	.actbutton2{
		width: 80px;
		height: 30px;
		line-height: 30px;
		font-size: 18px;
		color: #ffffff;
		background: #9e9e9e;
	}
	.actbox{
		width: 1100px;
		margin-top: 20px !important;
		margin: 0 auto;
	}
	.campitem{
		width: 340px;
		border-radius: 8px;
			color: #333;
	}
	.lessonitem{
		width: 257px;
		margin-bottom: 10px;
		color: #333;
	}
	.lessonitem:hover{
		color: #1b9d57;
	}
	.campitem:hover{
		color: #1b9d57;
	}
	.lessonimgbox{
		width: 257px;
		height: 177px;
		position: relative;
	}
	.lessonimgbox img{
		width: 100%;
		height: 100%;
	}
	.campimgbox{
		width: 340px;
		height: 168px;
		position: relative;
		
	}
	.actimgbox{
		width: 340px;
		height: 218px;
	}
	.actimgbox img{
		width: 100%;
		height: 100%;
	}
	.actpay{
		font-size: 14px;
		color: brown;
	}
	
	.campimgbox img{
		width: 100%;
		height: 100%;
		border-radius: 8px 8px 0px 0px;
	}
	.campaddress{
		width: 320px;
		position: absolute;
		bottom: 0;
		right: 0;
		z-index: 1;
		display: flex;
		justify-content: flex-end;
		align-items: flex-end;
		font-size: 12px;
		font-weight: 600;
		color: #ffffff;
		height: 26px;
		line-height: 26px;
		padding: 0 10px;
		background: #30313336;
	}
	.camptitle{
		padding: 10px;
		font-size: 18px;
		width: 320px;
		height: 46px;
	
		/* margin-bottom: 15px; */
		text-align: left;
		/* height: 50px; */
		/* line-height: 50px; */
		text-overflow: ellipsis;
		white-space: normal;
		overflow: hidden;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
	}
	.lessontitle{
		padding: 10px;
		font-size: 18px;
		width: 237px;
		height: 46px;
		text-align: left;
		text-overflow: ellipsis;
		white-space: normal;
		overflow: hidden;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
	}
	
	.imgsbox{
		/* width:1100px; */
		/* margin: 10px auto; */
	}
	.advbanner{
		width:1100px;
		margin: 0px auto;
	}
	.newsimgH{
		width: 210px;
		height: 135px;
		background-color: #333;
	}
	.newsitemH{
		width: 525px;
		padding: 10px;
		border-radius: 8px;
		display: flex;
		/* justify-content: ; */
		
		align-items: center;
		margin-bottom: 10px;
		background: #ffffff;
	}
	.newsitemH:hover{
		color: #1b9d57;
	}
	.newsitembox{
		width: 100%;
		margin-top: 10px;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		align-items: center;
	}
	.newsmsgH{
		width: 280px;
		height: 135px;
		margin-left: 20px;
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		justify-content: space-between;
	}
	.news_bottomH{
		width: 100%;
		display: flex;
		justify-content: space-between;
	}
	.newstitle{
		font-size: 18px;
		
	}
	.campbox{
		width: 1100px;
		margin: 0 auto;
	}
	::v-deep .el-tabs__header{
		margin: 0px !important;
	}
	::v-deep .el-tabs__item{
		font-size: 18px;
		height: 78px !important;
		line-height: 78px !important;
		/* padding:30px ; */
	}
/* 	.el-tabs__content{
		background: #f5f5f5;
	} */
</style>

<style>

/* 	.top_banner>.el-carousel>.el-carousel__indicators--horizontal{
		bottom: 180px;
	} */

	
	.el-tabs__active-bar{
		background-color: #1b9d57 !important;
	}
	.el-tabs__item{
		padding-left: 20px !important;
	}
	.el-tabs__nav-wrap{
		background: #ffffff;
	}
	
	.newsbox{
		width: 1100px;
		margin: 10px auto;
		display: flex;
	}
	.video{
		width: 50%;
		height: 350px;
		background-color: #333;
		margin-left: 10px;
	}
	.video video{
		width: 100%;
		height: 100%;
	}
	.news_box{
		display: flex;
		min-height: 400px;
		width: 100%;
		/* background: #ffffff; */
	}
	.news_item{
		padding: 10px;
		color:#333;
		width: 95%;
		border-bottom: 1px solid #d3d3d326;
		overflow: hidden;
		   white-space: nowrap;
		   text-overflow: ellipsis;
	}
	.news_item:hover
	{ 
		color:#1b9d57;
	    background-color:#ddfff0;
	}
	.newslefticon{
		width: 80px;
		height: 350px;
		writing-mode: vertical-lr;
		writing-mode: tb-lr;
		color: #ffffff;
		font-weight: 600;
		background: #3a8ee6;
		font-size: 30px;
		line-height: 80px;
		margin-left: 10px;
		margin-right: 10px;
	}
	.newslefticon img{
		width: 100%;
		height: 100%;
	}
	.actslefticon{
		width: 80px;
		height: 350px;
		writing-mode: vertical-lr;
		writing-mode: tb-lr;
		color: #ffffff;
		font-weight: 600;
		background: #3a8ee6;
		font-size: 30px;
		line-height: 80px;
		/* margin-left: 10px; */
		margin-right: 10px;
	}
	.actslefticon img{
		width: 100%;
		height: 100%;
	}
	.news_list{
		/* width: 40%; */
		width: 455px;
		height: 350px;
		/* border-radius: 10px; */
		    box-shadow: 2px -2px 14px 6px #3a8ee626;
			background: #ffffff;
		/* background:; */
	}
	.newsbox .el-carousel--card{
		width: 100%;
	}
	/* 图片轮播 */
	 .el-carousel__item h3 {
	    color: #475669;
	    font-size: 14px;
	    opacity: 0.75;
	    line-height: 150px;
	    margin: 0;
	  }
		
	  .el-carousel__item:nth-child(2n) {
	     background-color: #99a9bf;
	  }
	  
	  .el-carousel__item:nth-child(2n+1) {
	     background-color: #d3dce6;
	  }
	  
	
</style>